import React from 'react'
import { Box, ImageLoader, Text } from '@usap/uicomponents'

export default function SetKitDisplay({ parentSku, style, showPartNumber = true, isWmoEnabled = false, multipleItemsPresent }) {
  if (!parentSku) return null

  let wmoStyle = {}

  if(isWmoEnabled) {
    wmoStyle = {
      boxShadow: "unset",
      border: "1px solid #D4D4D6",
      marginBottom: "0",
      borderRadius: "4px"
    }
    if(multipleItemsPresent){
      wmoStyle = {
        ...wmoStyle,
        maxWidth: "500px",
        marginTop: "16px"
      }
    }
  }

  return (
    <Box
      pad={{ vertical: '8pt', horizontal: '12pt' }}
      elevation="small"
      style={style || { borderRadius: '6pt', marginBottom: '16pt', ...wmoStyle}}
    >
      <Text weight="bold" size="xsmall" color="dark-2" style={{ textAlign: isWmoEnabled && "left"}}>Included in:</Text>
      <Box direction="row">
        <Box pad="small" width="77px" height="80px">
          <ImageLoader
            fit="contain"
            alt={parentSku.sku_title}
            src={parentSku.ImageURL}
            width="100%"
            height="100%"
            cloudinaryParams="w_100,h_80"
          />
        </Box>

        <Box width="90%" pad="small" justify="center">
          <Text size="small" color="dark-2" dangerouslySetInnerHTML={{
            __html: parentSku.sku_title
          }} style={{ textAlign: isWmoEnabled && "left"}}>
          </Text>
          { showPartNumber && (
            <Text size="small" color="dark-1" style={{ textAlign: isWmoEnabled && "left"}}>
              Part no.:
              {' '}
              { ` ${parentSku.sku}`}
            </Text>
          )}
          <Text size="small" color="dark-2" style={{ textAlign: isWmoEnabled && "left"}}>
            Unit Price:
            <Text size="small" style={{ fontWeight: 'bolder' }}>
              {` $${parseFloat(parentSku?.list_price || '0').toFixed(2)}`}
            </Text>
          </Text>
        </Box>
      </Box>
    </Box>
  )
}
